import { AlertService } from "./alert.service";
import { Injectable } from "@angular/core";

@Injectable()
export class CopyClipboardService {

    constructor(private alertService:AlertService) { }

    public copyTableToText(table:string[][]) {
        if (!table) {
            throw new Error("Invalid table passed");
        }
        this.copyText(table.map(row => row.join(",")).join("\r\n"));
    }

    public copyText(content:string) {
        try {
            var textarea = document.createElement("textarea");
            textarea.id = "dac-copytext-textarea";
            textarea.value = content;
            document.body.appendChild(textarea);
      
            var copyTextarea = document.getElementById("dac-copytext-textarea") as HTMLInputElement;
            copyTextarea.select();
            var successful = document.execCommand('copy');
            document.body.removeChild(textarea);
            this.alertService.success("Copied To Clipboard!");
          } catch (err) {
            if (textarea) {
              document.body.removeChild(textarea);
            }
            this.alertService.error("Uh Oh! Looks like your browser doesn't support this feature.  Highlight the text and press Ctrl+C or CMD+C", 5000);
          }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/copy-clipboard.service.ts